import type { ReactNode } from "react";

import { Navigate, useLocation } from "react-router";

import { useSandboxAuth } from "sandbox/contexts/SandboxAuthContext";
import { sandboxPaths } from "sandbox/paths";

export const SandboxAuthGuard = ({ children }: { children: ReactNode }) => {
  const { isAuthenticated } = useSandboxAuth();
  const location = useLocation();

  if (!isAuthenticated) {
    return (
      <Navigate
        to={sandboxPaths.login}
        state={{ from: location.pathname }}
        replace
      />
    );
  }

  return <>{children}</>;
};
